import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Mapa from '../../components/Mapa';
import '../../assets/App.css';

const ANCHO_MAPA_BASE = 1100;

const Monitor = () => {
  const navigate    = useNavigate();
  const [usuario, setUsuario]       = useState(null);
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [escala, setEscala]         = useState(1);
  const [esMobil, setEsMobil]       = useState(false);

  const monitorRef = useRef(null);

  useEffect(() => {
    const data = localStorage.getItem('user_data');
    if (data) setUsuario(JSON.parse(data));

    const calcularEscala = () => {
      const ancho  = window.innerWidth;
      const movil  = ancho < 800;
      setEsMobil(movil);
      const margin = movil ? 10 : 40;
      setEscala(ancho - margin < ANCHO_MAPA_BASE ? (ancho - margin) / ANCHO_MAPA_BASE : 1);
    };

    const ro = new ResizeObserver(calcularEscala);
    if (monitorRef.current) ro.observe(monitorRef.current);
    window.addEventListener('resize', calcularEscala);
    calcularEscala();

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', calcularEscala);
    };
  }, []);

  const alturaMapaEscalada = 700 * escala;

  // En móvil: siempre visible (no hay hover)
  // En desktop: visible solo al hacer hover o si hay sesión activa
  const mostrarBoton = esMobil || mostrarMenu || !!usuario;

  return (
    <div
      ref={monitorRef}
      className="App"
      style={{ minHeight:'100vh', display:'flex', flexDirection:'column', background:'#ffffff', overflowX:'hidden', overflowY:'auto' }}
    >
      <style>{`
        .header-monitor {
          padding: 12px 40px;
          display: flex; justify-content: space-between; align-items: center;
          position: sticky; top: 0; left: 0; width: 100%; box-sizing: border-box;
          background: #000000; z-index: 100;
          box-shadow: 0 2px 10px rgba(0,0,0,0.3);
        }
        .header-left { display: flex; align-items: center; gap: 16px; }
        .logo-duoc   { height: 48px; }
        .linea-separadora { width: 2px; height: 36px; background: #FFB500; opacity: 0.7; }
        .txt-1 { font-weight: bold; font-size: 1.3rem; letter-spacing: 1px; color: #f2f3f3; line-height: 1.2; }
        .txt-2 { font-size: 0.85rem; color: #FFB500; font-weight: bold; letter-spacing: 2px; }
        .txt-3 { font-size: 1.5rem; color: #FFB500; font-weight: bold; letter-spacing: 2px; }

        .leyenda-mapa {
          display: flex; gap: 15px; justify-content: center; flex-wrap: wrap; /* Cambiado el gap de 20px a 15px */
          padding: 10px 20px; background: #f8f9fa;
          border-bottom: 1px solid #e0e0e0; font-size: 13px; font-weight: bold;
        }
        .leyenda-item { display: flex; align-items: center; gap: 6px; }
        .leyenda-dot  { width: 14px; height: 14px; border-radius: 3px; }

        @media (max-width: 800px) {
          .header-monitor   { padding: 10px 16px; flex-wrap: wrap; gap: 10px; }
          .logo-duoc        { height: 32px; }
          .linea-separadora { height: 26px; }
          .txt-1 { font-size: 0.95rem; }
          .txt-2 { font-size: 0.65rem; }
          .txt-3 { font-size: 1rem; }
        }
      `}</style>

      {/* ── HEADER ── */}
      <div
        className="header-monitor"
        onMouseEnter={() => setMostrarMenu(true)}
        onMouseLeave={() => setMostrarMenu(false)}
      >
        <div className="header-left">
          {/* Logo en dos capas: "Duoc" en amarillo, "UC" + ícono en blanco */}
          <div style={{ position:'relative', display:'inline-flex', alignItems:'center' }}>
            {/* Capa 1: imagen filtrada a amarillo, clip muestra solo "Duoc" (58% izquierdo) */}
            <img
              src="/DuocUC-1024x252.png"
              alt="Duoc"
              className="logo-duoc"
              style={{
                filter:   'brightness(0) saturate(100%) invert(78%) sepia(60%) saturate(600%) hue-rotate(2deg) brightness(105%)',
                clipPath: 'inset(0 46% 0 0)',
              }}
            />
            {/* Capa 2: imagen filtrada a blanco, clip muestra solo "UC + ícono" (42% derecho) */}
            <img
              src="/DuocUC-1024x252.png"
              alt="UC"
              className="logo-duoc"
              style={{
                position: 'absolute',
                top:      0,
                left:     0,
                filter:   'brightness(0) invert(1)',
                clipPath: 'inset(0 0 0 54%)',
              }}
            />
          </div>
          <div className="linea-separadora" />
          <div>
            <div className="txt-1">ESTACIONAMIENTOS</div>
            <div className="txt-2">DISPONIBILIDAD EN VIVO</div>
            <div className="txt-3">SEDE SAN BERNARDO</div>
          </div>
        </div>

        {/* El botón es siempre visible en móvil, oculto en desktop hasta hover */}
        <div style={{
          opacity:    mostrarBoton ? 1 : 0,
          transition: 'opacity 0.3s ease',
          // En móvil evitamos que quede inaccesible aunque opacity sea 0
          pointerEvents: mostrarBoton ? 'auto' : 'none',
        }}>
          {usuario ? (
            <div style={{ display:'flex', gap:'12px', alignItems:'center' }}>
              <span style={styles.badgeSesion}>
                Bienvenido, {usuario.first_name || usuario.username}
              </span>
              <button onClick={() => navigate('/dashboard')} style={styles.btnLogin}>
                PANEL
              </button>
            </div>
          ) : (
            <button onClick={() => navigate('/login')} style={esMobil ? styles.btnLoginMovil : styles.btnLoginGhost}>
              🔐 ACCESO INTERNO
            </button>
          )}
        </div>
      </div>

      {/* ── LEYENDA ── */}
      <div className="leyenda-mapa">
        <div className="leyenda-item"><div className="leyenda-dot" style={{ background:'#00ff00' }} />Disponible</div>
        <div className="leyenda-item"><div className="leyenda-dot" style={{ background:'#FF8C00' }} />Reservado</div>
        <div className="leyenda-item"><div className="leyenda-dot" style={{ background:'#e63946' }} />Ocupado</div>
        <div className="leyenda-item"><div className="leyenda-dot" style={{ background:'#cfe2f3' }} />Zona restringida</div>
        <div className="leyenda-item"><div className="leyenda-dot" style={{ background:'#000000' }} />Uso permanente</div>
        {esMobil && <span style={{ color:'#888', fontSize:'11px', width:'100%', textAlign:'center' }}>Toca un lugar ocupado para ver detalles</span>}
      </div>

      {/* ── CONTENEDOR DEL MAPA ── */}
      <div style={{
        flex:           1,
        display:        'flex',
        justifyContent: 'center',
        alignItems:     'flex-start',
        paddingBottom:  '40px',
        paddingTop:     '20px',
        minHeight:      alturaMapaEscalada + 60,
      }}>
        <div style={{
          transform:       `scale(${escala})`,
          transformOrigin: 'top center',
          transition:      'transform 0.15s ease-out',
        }}>
          <Mapa token={null} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  btnLogin: {
    background:   '#FFB500',
    color:        '#002D5C',
    border:       'none',
    padding:      '10px 24px',
    borderRadius: '30px',
    cursor:       'pointer',
    fontWeight:   'bold',
    fontSize:     '14px',
    touchAction:  'manipulation',
  },
  // Desktop: fantasma discreto
  btnLoginGhost: {
    background:   '#1b1a1a',
    border:       '1px solid #e5e9ec',
    color:        '#ececec',
    padding:      '8px 18px',
    borderRadius: '30px',
    cursor:       'pointer',
    fontSize:     '14px',
    touchAction:  'manipulation',
  },
  // Móvil: más visible, fondo amarillo para que destaque en el header negro
  btnLoginMovil: {
    background:   '#FFB500',
    border:       'none',
    color:        '#002D5C',
    padding:      '10px 18px',
    borderRadius: '30px',
    cursor:       'pointer',
    fontSize:     '13px',
    fontWeight:   'bold',
    touchAction:  'manipulation',
    whiteSpace:   'nowrap',
  },
  badgeSesion: {
    fontSize:   '13px',
    background: 'rgba(255,255,255,0.15)',
    color:      '#fff',
    padding:    '7px 12px',
    borderRadius:'20px',
    fontWeight: '500',
    border:     '1px solid #FFB500',
  },
};

export default Monitor;